module.exports = __webpack_public_path__ + "static/hash1-171e7d3e5573c673a41f4e12c1921bf2.png";